const typeListACH = [
    { type: 'OnlineBank', name: '網銀帳密驗證' }
];
typeListACH.forEach(i => {
    Object.freeze(i);
});
export default typeListACH;
